/**
 * Phase 2L-A20 — Australian date formatting helpers.
 *
 * Centralised front-end formatters. Use these everywhere a date is
 * rendered to a human; never call `toLocaleDateString()` /
 * `toLocaleString()` directly in components.
 *
 *   formatDateAU(d)     -> "DD/MM/YYYY"        (12/06/2026)
 *   formatDateTimeAU(d) -> "DD/MM/YYYY HH:mm"  (12/06/2026 14:35)
 *   formatTimeAU(d)     -> "HH:mm"             (14:35)
 *
 * Accepts: ISO string, Date, ms-since-epoch, or null/undefined.
 * Returns "—" for invalid / missing values rather than throwing —
 * date rendering should never crash a page.
 */

const pad = (n) => String(n).padStart(2, "0");

function _coerce(value) {
  if (value === null || value === undefined || value === "") return null;
  const d = value instanceof Date ? value : new Date(value);
  return isNaN(d.getTime()) ? null : d;
}

export function formatDateAU(value, fallback = "—") {
  const d = _coerce(value);
  if (!d) return fallback;
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
}

export function formatDateTimeAU(value, fallback = "—") {
  const d = _coerce(value);
  if (!d) return fallback;
  return `${formatDateAU(d)} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function formatTimeAU(value, fallback = "—") {
  const d = _coerce(value);
  if (!d) return fallback;
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
